import React from 'react';
import { MessageSquare } from 'lucide-react';
import ChatPanel from './ChatPanel';

export default function ChatPage() {
  return (
    <div className="chat-section">
      <div className="section-header">
        <div className="section-title">
          <div className="section-icon chat-icon"><MessageSquare size={24} /></div>
          <div><h2>المحادثات المباشرة</h2><p>تواصل مع المرضى بشكل مباشر وسريع</p></div>
        </div>
      </div>
      <ChatPanel />
    </div>
  );
}
